module.exports = __webpack_public_path__ + "static/media/NDUNECHE PIX. NEW.d8efe194.jpeg";